import { render, staticRenderFns } from "./DoctorSideBar.vue?vue&type=template&id=59448df8&scoped=true"
import script from "./DoctorSideBar.vue?vue&type=script&lang=js"
export * from "./DoctorSideBar.vue?vue&type=script&lang=js"
import style0 from "./DoctorSideBar.vue?vue&type=style&index=0&id=59448df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59448df8",
  null
  
)

export default component.exports